import React from "react";
import { useNavigate } from "react-router-dom";
import "../pages/Career.css";
import { FcSearch } from "react-icons/fc";

import c1 from "../assets/career1.jpg";
import c2 from "../assets/career2.jpg";
import c3 from "../assets/career3.png";
import c4 from "../assets/career4.jpg";
import c5 from "../assets/career5.jpg";
import c6 from "../assets/career6.jpg";
import c7 from "../assets/career7.jpg";
import c8 from "../assets/career8.png";
import c9 from "../assets/career9.jpg";
import cover from "../assets/career-cover-page.jpg";

const careers = [
  { title: "Merchandising", img: c1 },
  { title: "Design & Product Development", img: c2 },
  { title: "Quality Control", img: c3 },
  { title: "Production Management", img: c4 },
  { title: "Sales & Marketing", img: c5 },
  { title: "Logistics & Supply Chain", img: c6 },
  { title: "Graphic Designer / Photographer", img: c7 },
  { title: "Product Modeling", img: c8 },
  // keep as provided (duplicate allowed if intentional)
  { title: "Logistics & Supply Chain", img: c9 },
];

export default function Career() {
  const navigate = useNavigate();

  const handleRoleClick = (title) => {
    // Pass the clicked role to Contact page via router state
    navigate("/contact", { state: { role: title } });

    // If you prefer query params, use this instead:
    // navigate(`/contact?role=${encodeURIComponent(title)}`);
  };

  return (
    <div>
      <h1 className="career-heading">Career</h1>

      <div className="career-banner">
        <img src={cover} alt="Career Banner" />

        {/* Text Overlay */}
        <div className="career-text">
          <h1>Career at Maya Exports Ltd.</h1>
          <div className="career-para">
            <p>Grow with a Global Leader in Fashion &amp; Export At Maya Exports Ltd.</p>
            <p>We’re more than a workplace — We’re a family of Innovators, Creators, and Collaborators.</p>
            <p>With a strong presence in the Global Fashion and Garment Export Industry.</p>
            <p>We are always on the lookout for passionate professionals ready to make an impact.</p>
          </div>
        </div>
      </div>

      <div className="currentopening-div">
        <div className="currentopening-heading">
          <FcSearch size={50} />
          <h1>Current Openings</h1>
        </div>
        <p className="para">We are hiring across various departments including:</p>

        <div className="career-container">
          <div className="career-grid">
            {careers.map((career, index) => (
              <div
                key={index}
                className="career-card"
                onClick={() => handleRoleClick(career.title)}
                onKeyDown={(e) => e.key === "Enter" && handleRoleClick(career.title)}
                role="button"
                tabIndex={0}
                title={`Apply for ${career.title}`}
                style={{ cursor: "pointer" }}
              >
                <img src={career.img} alt={career.title} className="career-img" />
                <h3 className="career-title">{career.title}</h3>
                <p className="career-cta">Click to apply</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="careerLastDiv">
        <div className="careerLeftDiv">
          <img
            src="https://mayaexportsltd.com/wp-content/uploads/2025/07/businessman-walking-promotion-scaled.jpg"
            alt="Career growth visual"
          />
        </div>

        <div className="careerRightDiv">
          <h1>Career at Maya Exports Ltd.</h1>
          <p>Don’t see a position that fits? We still want to hear from you!</p>

          <div className="mailDiv">
            <p> 📧 Send Your Resume To: </p>
            <strong style={{ marginLeft: "10px", fontSize: "20px" }}>
              sophie_maya86@yahoo.com
            </strong>
          </div>

          <div>
            <p>💼 Internships &amp; Training</p>
          </div>

          <p style={{ width: "700px", maxWidth: "100%" }}>
            We also offer internships for students and recent graduates looking to build a career
            in the Fashion and Export industry.
          </p>
        </div>
      </div>
    </div>
  );
}
